export type InvitationStatus = 'PENDING' | 'REJECTED';

const OFFSET = 1000;

export const InvitationStatusMap : Record<InvitationStatus, string> = {
    PENDING: $localize`:@@invitationStatus.pending:In afwachting`,
    REJECTED: $localize`:@@invitationStatus.rejected:Geweigerd`,
};

export class Invitation {
    id = -1;
    email = '';
    organisationId = -1;
    organisationName = '';
    roleId = -1;
    roleName = '';
    status: InvitationStatus = 'PENDING';
    readableStatus: string = '';

    deserialize(data: any): this {
        this.id = data.id;
        this.email = data.email;
        this.organisationId = data.organisation_id;
        this.organisationName = data.organisation_name;
        this.roleId = data.role_id;
        this.roleName = data.role_name;
        this.status = data.status;
        this.readableStatus = InvitationStatusMap[this.status];
        return this;
    }

    static Sort(i1: Invitation, i2: Invitation): number {
        const status1 = i1.status === 'PENDING' ? 0 : 1;
        const status2 = i2.status === 'PENDING' ? 0 : 1;
        const roleDiff = i1.roleId - i2.roleId;
        return (status1 - status2) * OFFSET + roleDiff;
    }

    serialize(): any {
        return {
            id: this.id,
            organisation_id: this.organisationId,
            organisation_name: this.organisationName,
            role_id: this.roleId,
            role_name:  this.roleName,
            status: this.status,
            email: this.email,
        };
    }
}
